import React from 'react';

// Types
import { Illustrations } from 'Wpds/components/illustration';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';

// Components
import ItemDoesntExistError from 'Shared/components/ItemDoesntExistError/ItemDoesntExistError';
import NotificationListItem from './NotificationListItem';
import NotificationsLoading from './NotificationsLoading';

// Styles
import './NotificationsList.scss';

type Props = {
  notifications;
  isLoading: boolean;
};

const NotificationsList = ({ notifications, isLoading }: Props) => {
  const baseClassName = 'NotificationsList';

  if (isLoading && !(notifications.size > 0)) {
    return <NotificationsLoading />;
  }

  if (!isLoading && notifications.size === 0) {
    return (
      <ItemDoesntExistError
        image={Illustrations.person_relaxing_in_window_purple_bg}
        title=""
        description="All caught up here!"
      />
    );
  }

  return (
    <div className={baseClassName}>
      {notifications.valueSeq().map(notification => {
        const id = WorkspaceRecentUpdatesHelper.getId(notification);
        return <NotificationListItem notification={notification} key={id} />;
      })}
    </div>
  );
};

export default NotificationsList;
